export default __webpack_public_path__ + "923d094dd275918e930fbebae8327478.svg";